import { CoolingStatus } from '@features/siteStatusV2/constants/report';

const MapCoolingStatusToDisplay: Record<CoolingStatus, string> = {
  [CoolingStatus.INTERNAL_DATABASE_UPDATE]: 'report.reportType.internalDatabaseUpdate',
  [CoolingStatus.INSTALLATION_FAILED]: 'report.reportType.installationFailed',
  [CoolingStatus.ORDER_CANCELED]: 'report.reportType.orderCanceled',
  [CoolingStatus.SAV]: 'report.reportType.sav',
  [CoolingStatus.NO_STATUS]: '-'
};

export default MapCoolingStatusToDisplay;
